/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { useParams, useNavigate, useLocation } from "react-router-dom";

export function withParamsAndNavigate(Component) {
    return (props) => (
        <Component {...props} params={useParams()} navigate={useNavigate()} location={useLocation()} />
    );
}